<style scoped>

::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-thumb {
    background: rgba(191, 188, 188, 0.6);
}
.required_err {
    color: rgba(255, 0, 0);
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>

<div class="vifs">     
    <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        sort-by="id"
        class="elevation-1"
        @dblclick:row="on_dbl_click"
    >
    <template v-slot:top>
        <v-toolbar flat>
            <v-toolbar-title><h2 class="br">IPv6 interfaces</h2></v-toolbar-title>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" max-width="500px">
                <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card><v-form>
                    <v-card-title>
                        <span class="headline">IPv6 interface</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container style="height: 520px; overflow-y: scroll;">
                            <v-row>
                                <v-col cols="12">
                                    <div v-if="edited_index != -1">
                                        <v-text-field
                                            v-bind:readonly="edited_index != -1"
                                            v-model="edited_item.id"
                                            label="ID"
                                        ></v-text-field>
                                    </div>

                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <v-text-field
                                            v-bind:readonly="edited_index != -1"
                                            v-model="edited_item.name"
                                            label="Name"
                                        ></v-text-field>
                                        <span class="required_err">{{ errors[0] }}</span>
                                    </ValidationProvider>

                                    <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                                        <v-text-field
                                            v-bind:readonly="edited_index != -1"
                                            v-model="edited_item.port"
                                            label="Port"
                                        ></v-text-field>
                                        <span class="required_err">{{ errors[0] }}</span>
                                    </ValidationProvider>

                                    <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                                        <v-text-field
                                            v-bind:readonly="edited_index != -1"
                                            v-model="edited_item.svid"
                                            label="SVID. Service VLAN Id (Outer VLAN Id)."
                                        ></v-text-field>
                                        <span class="required_err">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                    
                                    <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                                        <v-text-field
                                            v-bind:readonly="edited_index != -1"
                                            v-model="edited_item.cvid"
                                            label="CVID. Client VLAN Id (Inner VLAN Id)."
                                        ></v-text-field>
                                        <span class="required_err">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                    
                                    <v-text-field
                                            v-bind:readonly="edited_index != -1"
                                            v-model="edited_item.ipv6_state"
                                            label="IPv6 state">
                                            <template #append>
                                                <v-btn :disabled="waiting == 1" 
                                                    v-if="edited_item.ipv6_state == 'disabled'"
                                                    color="blue lighten-4" @click="ipv6_enable()">Enable</v-btn>
                                                <v-btn :disabled="waiting == 1" 
                                                    v-if="edited_item.ipv6_state == 'enabled'"
                                                    color="blue lighten-4" @click="ipv6_disable()">Disable</v-btn>
                                            </template>                          
                                    </v-text-field>

                                    <v-text-field
                                            v-bind:readonly="edited_index != -1"
                                            v-model="edited_item.ipv6_nd_ra_state"
                                            label="ND Router Advertisement state">
                                            <template #append>
                                                <v-btn :disabled="waiting == 1" 
                                                    v-if="edited_item.ipv6_nd_ra_state == 'not advertising'"
                                                    color="blue lighten-4" @click="nd_ra_enable()">Enable</v-btn>
                                                <v-btn :disabled="waiting == 1" 
                                                    v-if="edited_item.ipv6_nd_ra_state == 'advertising'"
                                                    color="blue lighten-4" @click="nd_ra_disable()">Disable</v-btn>
                                            </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Close</v-btn>
                    </v-card-actions>
                </v-form></v-card></ValidationObserver>
            </v-dialog>

        </v-toolbar>
            <v-toolbar flat>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
        <v-icon small class="me-2" @click="edit_item(item)">
            mdi-pencil
        </v-icon>
    </template>

    <template v-slot:no-data>
    </template>

    </v-data-table>
</div>
</template>
  
<script>

import api_client from '../services/api.js';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import "../validation_rules.js";

export default {
    name: "ipv6_vif",
    components: { Treeselect, ValidationProvider, ValidationObserver },
    data: () => ({
        search: '',
        dialog: false,
        headers: [
            { text: 'Id', value: 'id', align: 'start' },
            { text: 'Name', value: 'name' },
            { text: 'Port', value: 'port' },
            { text: 'SVID', value: 'svid' },
            { text: 'CVID', value: 'cvid' },
            { text: 'IPv6 state', value: 'ipv6_state' },
            { text: 'ND Router Advertisement', value: 'ipv6_nd_ra_state' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],

        waiting: 0,
        items: [],
        edited_index: -1,
        edited_item: {},
    }),

    computed: {
    },

    watch: {
    },

    created() {
        this.initialize()
    },

    methods: {
        initialize() {
            api_client.sh_vifs()
            .then(response => {
                this.items = response.data
            })
            .catch(error => {
                console.log(error)
            })
        },

        edit_item(item) {
            this.edited_index = this.items.indexOf(item);
            this.edited_item = Object.assign({}, item);
            this.waiting = 0;
            this.dialog = true;
        },

        on_dbl_click(event, data) {
		    this.edit_item(data.item);
        },

        close() {
            this.dialog = false;
        },

        read_item() {
            api_client.sh_vif_with_name({ name: this.edited_item.name })
            .then(response => {
                if (this.edited_index != -1) {
                    Object.assign(this.items[this.edited_index], response.data);
                    this.edited_item = Object.assign({}, response.data);
                    this.waiting = 0;
                }
            })
            .catch(error => {
                console.log(error)
            })
        },

        ipv6_enable() {
            api_client.run_post_query('ipv6_vif/ipv6_enable', { name: this.edited_item.name })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.waiting = 1;
                    setTimeout(this.read_item, 3000);
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        ipv6_disable() {
            api_client.run_post_query('ipv6_vif/ipv6_disable', { name: this.edited_item.name })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.waiting = 1;
                    setTimeout(this.read_item, 3000);
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        nd_ra_enable() {
            api_client.run_post_query('ipv6_vif/nd_ra_enable', { name: this.edited_item.name })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.waiting = 1;
                    setTimeout(this.read_item, 3000);
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        nd_ra_disable() {
            api_client.run_post_query('ipv6_vif/nd_ra_disable', { name: this.edited_item.name })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.waiting = 1;
                    setTimeout(this.read_item, 3000);
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });            
        },     
    }
  };
  </script>
  